import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { PageLayoutComponent } from '../../components/shared/page-layout/page-layout.component';

@Component({
  selector: 'app-devis',
  standalone: true,
  imports: [CommonModule, FormsModule, RouterModule, PageLayoutComponent],
  templateUrl: './devis.component.html',
  styleUrl: './devis.component.scss'
})
export class DevisComponent implements OnInit {
  title = 'Demandez-nous des devis';
  subtitle = 'Gagnez du temps en passant par un courtier. Nous cherchons et comparons les offres pour vous et sans frais.';
  heroVideo = 'assets/videos/devis-video.mp4';
  
  breadcrumbs = [
    { label: 'Devis', link: undefined }
  ];

  prevPage = {
    title: 'Accueil',
    link: '/landing'
  };

  nextPage = {
    title: 'Contactez-nous',
    link: '/contact'
  };

  // Form data
  contactForm = {
    nom: '',
    prenom: '',
    email: '',
    telephone: '',
    message: ''
  };

  constructor(private router: Router) {}

  ngOnInit(): void {}

  submitForm(): void {
    console.log('Form submitted:', this.contactForm);
    // TODO: Implement form submission logic
  }
}
